/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CourseRole } from './CourseRole';
import { User } from './User';
const CourseEnrollmentParser = /* #__PURE__ */ parsers.object([
    ['user', User],
    ['courseRole', CourseRole, 'course_role'],
]);
export class CourseEnrollment extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseEnrollmentParser.decode(input).map(res => new CourseEnrollment(res));
    }
    static unsafeDecode(input) {
        return CourseEnrollment.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseEnrollmentParser.encode(data);
    }
    static schema() {
        return CourseEnrollmentParser.schema();
    }
}
